import { makeStyles } from '@material-ui/core/styles';

export const useTypography = makeStyles((theme) => ({
  pageTitle: {
    fontFamily: `Kanit,${theme.typography.h5.fontFamily}`,
    fontWeight: 400,
  },
}));
